var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZilliqa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3110_5764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0482 11.4624L7.75533 16.0511L17.0482 20.4671V23.9999L3.51221 17.5871V14.0735L12.9393 9.4655L3.51221 5.01106V1.43994L17.0482 7.87194V11.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51221 1.44L7.10245 0L20.6386 6.41288L17.0482 7.872L3.51221 1.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0482 11.4624L20.6387 10.0224V6.4126L17.0482 7.87211V11.4624ZM17.0482 20.467V13.363L20.6387 11.7119V22.5599L17.0482 23.9999V20.467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3110_5764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilliqa);
export default __webpack_public_path__ + "static/media/zilliqa.8e60f6762042a26fe1a77aa8c99b6d11.svg";
export { ForwardRef as ReactComponent };